angular.module('manageSysManageOtherConfigurationModule', ['otherConfigurationServiceModule'])
	.controller('manageSysManageOtherConfigurationCtrl', ['$q','$scope', 'modalDialog', 'trsspliceString', 'trsHttpService','otherConfigurationService', 
		function($q, $scope, modalDialog, trsspliceString, trsHttpService, otherConfigurationService){
		initStatus();
		requestData();

		function initStatus() {
			$scope.status = {
                batchOperateBtn: {
                    "hoverStatus": ""
                }
            };
            $scope.page = {
                "CURRPAGE": 1,
                "PAGESIZE": 20,
                "ITEMCOUNT": 0,
            };
            $scope.data = {
            	selectedArray:[],
            	items:[],
            	copyCurrPage: 1,
            }
		}

		//下一页
        $scope.pageChanged = function() {
            $scope.data.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };

        //跳转指定页面
        $scope.jumpToPage = function() {
            if ($scope.data.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.data.copyCurrPage = $scope.page.PAGECOUNT;
            }
            $scope.page.CURRPAGE = $scope.data.copyCurrPage;
            requestData();
        };
        /**
         * [selectPageNum description]单页选择分页数
         * @return {[type]} [description]
         */
        $scope.selectPageNum = function() {
            $scope.data.copyCurrPage = 1;
            requestData();
        };
		/**
         * [requestData description:数据请求方法：获取列表信息]
         */
        function requestData() {
            var defer = $q.defer();
            var params = {
                serviceid: "mlf_usersysconfig",
                methodname: "queryUserSysConfigs",
                CurrPage: $scope.page.CURRPAGE,
                PageSize: $scope.page.PAGESIZE,
                CName: $scope.data.keywords?$scope.data.keywords:"",
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                $scope.data.items = data.DATA;
                $scope.page = data.PAGER;
                $scope.data.selectedArray = [];
                defer.resolve();
            });
            return defer.promise;
        }
        /**
         * [selectAll description:全选]
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
            cancelBatchOperate();
        };
        /**
         * [selectDoc 单选]
         * @param  {[type]} item [description：单个对象] 
         */
        $scope.selectDoc = function(item) {
            if ($scope.data.selectedArray.indexOf(item) < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            }
            cancelBatchOperate();
        };
        /**
         * [cancelBatchOperate description：取消批量操作的样式]
         */
        function cancelBatchOperate() {
            if ($scope.data.selectedArray.length === 0) {
                $scope.status.batchOperateBtn = {
                    "hoverStatus": "",
                    "clickStatus": ""
                };
            }
        }
        /**
         * [search description;检索:模糊查询列表(全文检索)]
         * @param  {[type]} ev [description:按下空格也能提交]
         */
        $scope.search = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
            	$scope.data.copyCurrPage = $scope.page.CURRPAGE = 1;
                requestData();
            }
        };

		/**
         * [newOtherConfiguration description]新建其他配置
         */
        $scope.newOtherConfiguration = function() {
            otherConfigurationService.createOrEditOtherConfig("").then(function(data) {
                requestData();
            }, function(data) {
                //失败
            });
        };
        /**
         * [editOtherConfiguration description]修改其他配置
         */
        $scope.editOtherConfiguration = function(item) {
            otherConfigurationService.createOrEditOtherConfig(item).then(function(data) {
                requestData();
            }, function(data) {
                //失败
            });
        };
        /**
         * [refreshOtherConfiguration description]刷新页面
         * @return {[type]} [description]
         */
        $scope.refreshOtherConfiguration = function(){
        	requestData();
        };
        /**
         * [deleteOtherConfiguration description]删除其他配置
         */
        $scope.deleteOtherConfiguration = function() {
            modalDialog.confirmModal("删除其他配置", "是否确认将选中的配置删除", function() {
                var params = {
                    serviceid: "mlf_usersysconfig",
                    methodname: "deleteUserSysConfig",
                    ConfigIds: trsspliceString.spliceString($scope.data.selectedArray, 'CONFIGID', ","),
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    modalDialog.alertType("删除成功", "", "success", false, function() {
                        requestData();
                    });
                });
            });
        };

	}]);